/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Quota_Updated_AtInputs */

const en_quota_updated_at = /** @type {(inputs: Quota_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated at ${i?.time}`)
};

const fr_quota_updated_at = /** @type {(inputs: Quota_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mis à jour à ${i?.time}`)
};

const ms_sg2_quota_updated_at = /** @type {(inputs: Quota_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dikemas kini pada ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Updated at {time}" |
*
* @param {Quota_Updated_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const quota_updated_at = /** @type {((inputs: Quota_Updated_AtInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quota_Updated_AtInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quota_updated_at(inputs)
	if (locale === "fr") return fr_quota_updated_at(inputs)
	return ms_sg2_quota_updated_at(inputs)
});